module.exports = __webpack_public_path__ + "static/media/highway.ee130a13.svg";